import(/* webpackMode: "eager" */ "/vercel/path0/src/app/footer/learnerprivacy/page.js");
